export default [
  {
    activation_code: "Aktiveringskode",
    additional_instructions: "Yderligere instruktioner",
    building_number: "Bygningsnummer",
    card_name: "Kortnavn",
    card_number: "Kortnummer",
    city: "By",
    comment: "Din kommentar her",
    day: "Dag",
    dropoff_address: "Leveringsaddresse",
    email: "E-mail",
    first_name: "Fornavn",
    floor: "Etage",
    invalid: "Ugyldig",
    invalid_credit_card: "Ugyldigt kreditkort",
    invalid_cvv: "Feltet skal indeholde 3 numre",
    invalid_email: "Ugyldig email",
    invalid_max: "Ugyldig. Den skal være større end minimumsvalget",
    invalid_max_amount: "Beløbet kan ikke være højere end det samlede beløb",
    invalid_percent: "Ugyldig, skal værdien være 0 og 100",
    invalid_phone_number: "Ugyldigt telefonnummer",
    invalid_repeat_password: "Adgangskoden passer ikke",
    last_name: "Efternavn",
    location: "Beliggenhed",
    min_password: "Den skal indeholde mindst 8 tegn",
    phone_number: "Telefonnummer",
    postal_code: "Postnummer",
    required: "* Påkrævet",
    street: "Gade",
    time: "Tid",
    password: "Adgangskode",
    new_password: "Nyt adgangskode",
    repeat_new_password: "Gentag ny adgangskode",
  },
];
